import React from 'react';
import "./Content.css";

function Content() {
  return (
    <div className="content">
    <h1>I'm Robin</h1>
   <p>I am a Full Stack Web Developer love to build Web Applications</p> 
    </div>
  )
}

export default Content;